"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Wrap = (0, _styled.default)('div')(function (_ref) {
  var colors = _ref.theme.colors,
      isActive = _ref.isActive;
  return {
    position: 'relative',
    display: 'flex',
    cursor: 'pointer',
    width: '5rem',
    minWidth: '5rem',
    height: '5rem',
    backgroundColor: colors.white,
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    svg: {
      transition: 'fill .3s ease-in-out',
      fill: isActive ? colors.black : 'transparent'
    }
  };
});
var _default = Wrap;
exports.default = _default;